module.exports = HomeCtrl;

// @ngInject
function HomeCtrl($state, localStorageService, Alert, $anchorScroll) {
  try {
    const vm = this;
    vm.moduleName = 'HomeCtrl';

    console.log(vm.moduleName, localStorageService.get('state'))
    switch (localStorageService.get('state')) {
      case 'INIT':
          console.log(vm.moduleName, 'Re-direct INIT to unknown');
          $state.go('unknown');
      break;
      case 'VERIFY':
        console.log(vm.moduleName, 'Re-direct VERIFY to onsite');
        $state.go('onsite');
        break
      case 'ONSITE':
        console.log(vm.moduleName, 'Re-direct ONSITE to messages');
        $state.go('messages');
        break
      default:
          console.log(vm.moduleName, 'Re-direct other to unknown');
        $state.go('unknown');
        break;
    }
  } catch(error) {
    Alert.addAlert({ title: 'Error', message: 'Unexpected error: ' + error, type: 'errorAlert', alertClass: 'alert-danger'});
    $anchorScroll();
  }
}